// Responsáveis REAIS de uma produção: os ligados à produção e os das tarefas dela.
// Os do orçamento (previsto) ficam de fora. O servidor devolve o campo como "producaoId"
// (as telas procuravam "producoesId", que não existe, e nunca achavam ninguém).

// { tarefaId: producaoId } — para responsáveis antigos que só têm a tarefa preenchida
export async function carregarProducaoDasTarefas(apiCall) {
  try {
    const tarefas = await apiCall('TarefasProjeto');
    const mapa = {};
    (Array.isArray(tarefas) ? tarefas : []).forEach(t => {
      const id = t.id ?? t.Id ?? t.ID;
      const producaoId = t.producaoId ?? t.ProducaoId;
      if (id != null && producaoId != null) mapa[id] = producaoId;
    });
    return mapa;
  } catch {
    return {};
  }
}

export function producaoDoResponsavel(r, producaoDaTarefa = {}) {
  const producaoId = r.producaoId ?? r.ProducaoId ?? r.producoesId ?? r.ProducoesId;
  if (producaoId != null) return producaoId;
  const tarefaId = r.tarefasId ?? r.TarefasId;
  return tarefaId != null ? producaoDaTarefa[tarefaId] : undefined;
}

export function ehResponsavelDaProducao(r, producaoId, producaoDaTarefa = {}) {
  if ((r.orcamentoId ?? r.OrcamentoId) != null) return false;
  const daProducao = producaoDoResponsavel(r, producaoDaTarefa);
  return daProducao != null && String(daProducao) === String(producaoId);
}
